module.exports = __webpack_public_path__ + "static/media/vk.2c033baa.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Projects/MU/assets/vk.png
// module id = 189
// module chunks = 0